
import React, {Component} from 'react';
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Link from '@material-ui/core/Link';
import Aztec from './Aztec.png';
import SmallH1 from './HexagonSmall1.jpg';
import SmallH2 from './HexagonSmall2.jpg';
import SmallH3 from './HexagonSmall3.jpg';
import SmallH4 from './HexagonSmall4.jpg';
import Lozplustile from './hexplustiles.jpg';
import bell from './bell.jpg';
import TW from './TW.jpg';

import BigHcircle from './HexagonBigCircle.jpg';

const floatRight = { float: 'right', margin: '0 0 1em 1.5em', width: '30%' };
const centered   = { textAlign: 'center', margin: '1.5em 0' };
const framed     = { border: '1px solid grey' };

const classes= {
    root : {
        flexGrow: 1,
        padding: 5,
        backgroundColor: '#b2dfdb',
        color: '#6a737b',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: 30,
        elevation: '20',
    },
    h1 : {
    paddingLeft: 0 ,
    color: '#009688',
    marginTop:0,
    marginBottom:10,
    marginLeft:0 },
   
    p :{
        color: '#333333' ,
        paddingLeft: 0,
        marginTop:30,
        marginBottom: 30},
    pImag :{
            color: '#333333' ,
            paddingLeft: 'auto',
            paddingRight: 'auto',
            paddingTop: '3%',
            justifyContent: 'center',
            alignItems: 'center',}   
          
    }

export class Research extends Component {

    render() {
        return ( 
            <div style={{align:'left', margin:'7%',marginTop:70, backgroundColor: '#E6EBE9',
            padding:'3%'}}>
        <Grid  container  spacing={0} style={{marginLeft:0, paddingBottom:50, borderLeft: '0.03em solid grey'}}>
        <Grid item xs={12} sm={12} style={{margin:0, paddingTop:0, paddingLeft:'3%',paddingRight:'3%'}} >
        <Typography variant="h4" style={classes.h1}>
            My Research
        </Typography>
        <Typography  style={classes.p}> 
            Here you will find some information about my research interests and activities. 
        </Typography>
        <Typography variant="h4" style={classes.h1}>
            Research interests
        </Typography>
        <Typography  style={classes.p}> 
                Most of my research is on random matrices and integrable probability.  I am interested in universality phenomena 
            in the asymptotic behavior of microsopic systems when such systems are large. 
        </Typography>

        <Typography  style={classes.p}> 
                In 2021 I received an ERC consolidator grant for the project "Patterns in Random Tilings" (PiRaT). The overall goal of this project is study the behavior of random tilings of large planar domains and related models and their integables structure. If you wonder what random tilings of planar domains are and why they are interesting then you can read the popular research description below.
        </Typography>
        <Typography paragraph style={classes.p}> 
                Some key words:
          
       <ul style={{margin: '10px 0px', color: '#009688'}}>
        <li style={{marginBottom:10}}>  
                <span style={{color: '#333333'}}> Determinantal point process: eigenvalues of random matrices, random tilings,
                interlacing particle systems, non-colliding processes
                </span>
       </li>
       <li style={{marginBottom:10}}>
           <span style={{color: '#333333'}}>
                Universality: CLTs on macroscopic and mesoscopic scales and log-correlated fields, bulk and edge universality, critical phenomena.
                </span>
       </li>

       <li style={{marginBottom:10}}>
       <span style={{color: '#333333'}}>
       Asymptotic analysis: Plancherel-Rotach asymptotics for orthogonal polynomials,
                    spectra and determinants of large Toeplitz matrices,
                     Riemann-Hilbert problems, steepest descent techniques. 
                     </span>
       </li >
       <li style={{marginBottom:10}}>
       <span style={{color: '#333333'}}>
       Special functions: orthogonal polynomials,  Painlevé transcendents.
       </span>
       </li>

           </ul>
           </Typography>
                
           
        </Grid>
           
            
            </Grid>
       
            <Grid item xs={12} sm={12}  style={{paddingLeft:'3%',borderLeft: '0.03em solid grey'}}>
            <Typography variant="h4" style={classes.h1}>
            Popular Research Description
        </Typography>
            <Typography variant="h4" style={classes.h1}>
    Research for a General Audience
  </Typography>

  <Typography style={classes.p}>
    One of the remarkable facts of nature is that large systems made up of many small random
    parts often behave in a very predictable way. The objects around us appear static and
    orderly, yet they are built from atoms that individually move about quite erratically.
    Why does this chaos at the smallest scales disappear at the scale on which we live? How can
    a huge collection of random particles form a solid, stable object? A central challenge for
    mathematicians is to develop a rigorous framework for understanding the mechanisms behind
    such phenomena. We often approach this by studying mathematical models that are
    “simple” enough to be analyzed in detail, yet rich enough to capture the essential
    features. A deeper understanding of these models frequently reveals new, and sometimes
    unexpected, connections and predictions, which in turn inspire developments in related
    sciences.
  </Typography>

  <Typography style={classes.p}>
    <img src={bell} alt="Probabilities for the number of tails in 50 coin tosses, with the bell curve" style={floatRight} />
    Let us start with an example that many will recognize. In school we learn that histograms of
    all kinds of data—from people’s heights to errors in lab measurements—tend to have the
    shape of a bell. Why this bell-shaped curve appears is a classical question that is now well
    understood. The first proof that it really does appear, and that it is given by the Gaussian
    curve, was found by De Moivre around 1733 for repeated coin tosses. Toss a coin 50 times
    and count how often it lands on tails. The result will most likely be close to 25. The figure
    on the right shows the probability of each possible outcome: the closer the outcome is to 25,
    the higher the bar and the more likely that outcome is. Together, the bars take the shape of a
    bell (the red curve), and the more often we toss the coin, the better the bell curve fits.
  </Typography>

  <Typography style={classes.p}>
    By the Central Limit Theorem (proved in great generality by Lindeberg in 1922), this bell
    curve is <em>universal</em>: it appears in many other situations as well. The coin tosses are
    just a model in which everything can be computed explicitly; they can be replaced by many
    other kinds of random events, as long as these are <em>independent</em>—that is, the
    outcome of one toss does not influence the others. Mathematicians have thus proved that the
    bell curve appears, computed its exact shape, and shown that it is universal by understanding
    the mechanism behind it. And with the exact shape in hand, we can go on to study finer
    properties.
  </Typography>

  <Typography style={classes.p}>
    Physical systems with many interacting particles, such as atoms or electrons, are far more
    complicated than coin tosses. The particles can still be thought of as random, but they are
    certainly not independent: they interact with each other through the forces of physics. To
    understand such systems we have to drop the assumption of independence, which means going
    beyond the classical theory and developing new mathematics.
  </Typography>

  <Typography style={classes.p}>
    Let us look at an example that has been studied intensively by mathematicians over the past
    decades. Take a hexagon and cover it completely with tiles of three types. All tiles have the
    same lozenge (diamond) shape, but they come in three different orientations—you may
    recognize the shape from a well-known kind of licorice.
  </Typography>

  <div style={centered}>
    <img src={Lozplustile} alt="A hexagon and the three types of lozenge tiles" style={{ width: '55%' }} />
  </div>

  <Typography style={classes.p}>
    There are of course many ways to tile the hexagon, and we pick one at random: imagine putting
    all possible tilings in a bag and drawing one, each with the same probability. We can think of
    such a random tiling as a system of random particles, with the lozenges playing the role of
    the microscopic building blocks. At first sight it is not at all clear why this should be a good
    model for the complex physical systems described above. A first observation is that the
    lozenges are not independent. If you place a few tiles at different spots in the hexagon and
    then try to complete the tiling, you will often find that this is impossible without
    overlapping tiles, which are not allowed. Some configurations are simply forbidden, and this
    creates dependence in the system. Remarkably, this can be made precise, and one can show
    that there is a close analogy between random tilings and so-called Coulomb gases: roughly
    speaking, the tiles of one type behave like electrons that repel each other through the
    electric force.
  </Typography>

  <Typography style={classes.p}>
    The question we would like to answer is simple: what does a random tiling look like? At first,
    this may seem like a dull question. If we draw a few samples, we do not see much structure:
  </Typography>

  <div style={centered}>
    {[SmallH1, SmallH2, SmallH3, SmallH4].map((src, i) => (
      <img key={i} src={src} alt={`Random tiling of a small hexagon, sample ${i + 1}`} style={{ ...framed, width: '20%', margin: '0 0.5%' }} />
    ))}
  </div>

  <Typography style={classes.p}>
    Each picture looks different from the others. The situation is much like rolling a die: the
    outcome can be any number from 1 to 6, and not much can be said about a single throw.
    But this is because the hexagon is small. What happens if we take a very large hexagon
    (or, equivalently, make the tiles very small)? Then we obtain a picture like this one:
  </Typography>

  <div style={centered}>
    <img src={BigHcircle} alt="Random tiling of a large hexagon showing frozen corners and a disordered region inside a circle" style={{ ...framed, width: '70%' }} />
  </div>

  <Typography style={classes.p}>
    Now there is a lot of structure! In each corner only one type of tile appears, and all the
    randomness is confined to a region bounded by a circle. We say that the corners are
    “frozen”, and the boundary of the random region is known as the <em>arctic circle</em>.
    Would you have expected such frozen corners to appear?
  </Typography>

  <Typography style={classes.p}>
    <img src={TW} alt="The Tracy–Widom distribution" style={floatRight} />
    This picture raises many interesting questions. Can one prove that a circle really appears,
    and why are the corners frozen? And what about the fluctuations? For instance, once we
    know that the circle appears in the limit of large hexagons, what can we say about the
    random fluctuations of the boundary of the disordered region around this circle? It turns out
    that these fluctuations are described by the so-called Tracy–Widom distribution, shown on
    the right. This law was discovered by Tracy and Widom in the 1990s in random matrix theory,
    and it is different from the bell curve of the classical Central Limit Theorem. Yet, just like
    the bell curve, the Tracy–Widom distribution is believed to be universal: it appears in many
    systems in physics, including certain models of random growth, and understanding its full
    scope is a very active area of research. Random tilings have many other fascinating
    properties as well, with deep connections to theoretical physics. It is remarkable that such a
    seemingly simple model has so many rich features in common with complex systems in
    nature.
  </Typography>

  <Typography style={classes.p}>
    Discovering and understanding new behavior in large random systems, and proving that this
    behavior is universal, is a central theme of my research.
  </Typography>
</Grid>

        
        
        </div>
        )
    }
}

export default Research;